import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';

/** `<Indicator>` component. */
export const Indicator = ({ className, ...props }: Props): ReactElement => (
  <div
    className={twMerge('rounded bg-base-300/25 p-6 text-base text-warning', className)}
    {...props}
  >
    <Icon icon='move' title='Device requires calibration.' />
  </div>
);
